import { withMotion } from '../hoc/with-motion';
import { PlayerAllPodcasts } from '@/modules/player/components/all-podcast';


const AnimatedPage = withMotion(PlayerAllPodcasts);

export const roles: string[] = [];
export const path = '/player/all-podcasts';
export const element = <AnimatedPage />